export default {
    name: "category-item",
    props: ["title"],
};
